import { Language } from 'src/translation'
import { ListSelfSchedule } from './self-schedule'
import { ChannelAiConfigDraft } from './ai-config'
import { DraftMessages, RecordTemplateTypeMessage } from './messages'

export enum BotFlowType {
    READONLY = 'READONLY',
    ROBOT = 'ROBOT'
}

export enum NodeType {
    ALREADY_REGISTERED = 'ALREADY_REGISTERED',
    NOT_REGISTERED = 'NOT_REGISTERED',
    NO_OPEN_TICKET = 'NO_OPEN_TICKET',
    HAS_OPEN_TICKET = 'HAS_OPEN_TICKET',
    CREATE_NEW_TICKET = 'CREATE_NEW_TICKET',
    FOLLOW_OPEN_TICKET = 'FOLLOW_OPEN_TICKET',
    NOTIFICATION_USER = 'NOTIFICATION_USER'
}

export enum NodeTypeSelfSchedule {
    I_HAVE_A_VEHICLE = 'I_HAVE_A_VEHICLE',
    I_DONT_HAVE_A_VEHICLE = 'I_DONT_HAVE_A_VEHICLE',
    WITH_MULTISERVICES = 'WITH_MULTISERVICES',
    NO_MULTISERVICES = 'NO_MULTISERVICES',
    CONTINUE_NO_NOTE = 'CONTINUE_NO_NOTE',
    ENTERED_A_NEW_DATE = 'ENTERED_A_NEW_DATE',
    CUSTOMER_CONFIRMS_INFORMATION = 'CUSTOMER_CONFIRMS_INFORMATION',
    CUSTOMER_RECEIVES_ALL_SCHEDULING_INFORMATION = 'CUSTOMER_RECEIVES_ALL_SCHEDULING_INFORMATION',
    CUSTOMER_CLICKS_BACK_ALL = 'CUSTOMER_CLICKS_BACK_ALL',
    TYPE_WITH_OBSERVATION = 'TYPE_WITH_OBSERVATION',
    CHOSE_THE_TIME = 'CHOSE_THE_TIME'
}

export enum ClonedNodeIds {
    SEGMENTATION_CLONE_ONE = '3edb7c12-0376-50e1-9a86-ac2485f649e2',
    SEGMENTATION_CLONE_TWO = '5c7a08ff-a84d-5563-87b7-bef4b39d123f',
    SEGMENTATION_CLONE_THREE = 'ba5d3729-52f3-50d1-9aea-9810b7c06f12',
    SERVICE_CLONE = '6c2a7a5a-63ac-5c50-bd0b-ebbbfdc47c55',
    SELF_SCHEDULE_TIME_CLONE = '8ac5b1a9-7576-5a92-8884-9b79250ed7bf'
}

export const UUID_NAMESPACE = '3f678bea-90a3-4a85-9c4d-21bcb44d9fbb'

export type BotFlowItemValue = {
    id?: string
    idProp?: number
    text?: string
}

export type BotFlowItemLabelValue = {
    name: string
    companyId?: number
}

export type BotFlowSchuduleItem = {
    placa?: string
    time?: string
    description?: string
    modelId?: string
}

export type CompanyMenuSelfService = {
    _id: string
    companyId?: number
    name: string
    segmentations?: string[]
}

export type Menu = {
    _id: string
    description: string
    menuType: number
    key: string
    name: string
    listSubService?: string[]
}

export type BotFlowItemMenuGroup = {
    companies: CompanyMenuSelfService[]
    menus: Menu[]
}

export type BotFlowAnswerItem = BotFlowItemValue | BotFlowItemLabelValue | BotFlowItemMenuGroup | BotFlowSchuduleItem

export type BotFlowEdge = {
    id: string
    source: string
    target: string
    label?: string
    sourceHandle?: string
    targetHandle?: string
}

export type BotFlowNode = {
    id?: string
    type?: BotFlowType
    data: {
        message: string
        messageInfo: RecordTemplateTypeMessage
        answer: {
            items?: BotFlowAnswerItem[]
            type?: 'TEXT' | 'LIST' | 'BUTTON'
        }
        type: BotFlowType
        isMock?: boolean
        hideStep?: boolean
        name?: string
    }
    name?: string
}

export declare type BotFlowRequest = {
    adminChannel: {
        group: string
        phone: string
        aiConfig?: ChannelAiConfigDraft
        draftMessages?: DraftMessages
    }
    language: Language
    ignoreCache: boolean
    companyId?: number
}

export type BotFlowResponse = {
    nodes?: BotFlowNode[]
    edges?: BotFlowEdge[]
    activeCompaniesInSelfScheduling?: ListSelfSchedule
    aiConfig?: ChannelAiConfigDraft
}

export type DraftBotFlow = { save?: string[]; remove?: string[] }
